export const config = {
    currencySymbol: 'INR',
    currencyDecimals: 2
  };
  